import PropTypes from 'prop-types';
import React from 'react';
import { intlShape } from 'react-intl';
import { BookingSummaryDateTime } from '../common/items/BookingSummaryDateTime';
import { BookingSummaryListing } from '../common/items/BookingSummaryListing';
import { PricingSkeleton } from '../common/items/PricingSkeleton';
import { BookingPriceBreakdown } from '../common/items/booking-price-breakdown/BookingPriceBreakdown';

export const BookingRequestSummary = ({
  booking,
  listing,
  profile,
  masterContract,
  addOnsContracts,
  showSkeleton,
  intl
}) => {
  return (
    <div className='border-gray-200 padding-xl-left padding-xl-right padding-xl-top padding-xl-bottom'>
      <BookingSummaryListing listing={listing} intl={intl} />

      <hr className='w-100' />

      <BookingSummaryDateTime currentBooking={booking} />

      <hr className='w-100' />

      {showSkeleton ? (
        <PricingSkeleton />
      ) : (
        <BookingPriceBreakdown
          booking={booking}
          listing={listing}
          profile={profile}
          masterContract={masterContract}
          addOnsContracts={addOnsContracts}
          intl={intl}
        />
      )}
    </div>
  );
};

BookingRequestSummary.propTypes = {
  booking: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  masterContract: PropTypes.object.isRequired,
  addOnsContracts: PropTypes.arrayOf(PropTypes.object),
  showSkeleton: PropTypes.bool,
  intl: intlShape
};
